import { render, staticRenderFns } from "./form-component.vue?vue&type=template&id=3bddff08&scoped=true"
import script from "./form-component.vue?vue&type=script&lang=js"
export * from "./form-component.vue?vue&type=script&lang=js"
import style0 from "./form-component.vue?vue&type=style&index=0&id=3bddff08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bddff08",
  null
  
)

export default component.exports